import * as React from 'react';
import * as points from "./style.module.scss";
export const Points = () => {
  return (
    <section className={points.points}>
      <div className="container">
        <h2>Вы научитесь</h2>
        <ul>
          <li>
            <p>Запоминать иностранные слова любого языка</p>
          </li>
          <li>
            <p>Со скоростью <br/>70-150 новых слов в&nbsp;час</p>
          </li>
          <li>
            <p>В долговременную память</p>
          </li>
          <li>
            <p>Со&nbsp;100% точностью</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
